import Vue from 'vue';

// 普通商品订单列表
export function orderRefund(target, params, loading) {
  return Vue.ajaxPost(target, `${global.apiUrl}/order/refund`, params, loading);
}
// 普通商品订单列表
export function featchOderdetail(target, params, loading) {
  return Vue.ajaxGet(target, `${global.apiUrl}/order/itemAndTrade`, params, loading);
}
// 核销记录
export function featchRecord(target, params, loading) {
  return Vue.ajaxGet(target, `${global.apiUrl}/order/tradeItems`, params, loading);
}
// 退款Table
export function refoundGoods(target, params, loading) {
  return Vue.ajaxGet(target, `${global.apiUrl}/order/valid/tradeItems`, params, loading);
}
// 退款
export function refound(target, params, loading) {
  return Vue.ajaxPost(target, `${global.apiUrl}/order/refund/v2`, params, loading);
}
// 查询微信退款详情
export function fetchRefundWechatDetail(target, params, loading) {
  return Vue.ajaxGet(target, `${global.apiUrl}/order/refund-wechat-detail`, params, loading);
}
